import { compile, debounce, morph } from "../../libs/utils";

function animateSvgs() {
	const animatedBlocks = document.querySelectorAll(
		".animated-svg.wp-block-eyeworkers-svg"
	);

	// Return if no animated svg is found
	if (!animatedBlocks) return;

	const newTitle = "Svg Egde";

	for (let i = 0; i < animatedBlocks.length; i++) {
		// Find the SVGs that need animation, via title check
		const svgs = animatedBlocks[i].getElementsByTagName("svg");
		for (let j = 0; j < svgs.length; j++) {
			const title = svgs[j].getAttribute("title");

			if (title && title != newTitle) {
				const block = svgs[j];
				const animatePath = title;
				// Return if block counld not be found
				if (!block || !animatePath) return;
				block.setAttribute("title", newTitle);

				const pathElement = block.getElementsByTagName("path")[0];
				const path = pathElement?.getAttribute("d");
				// Return if no original path is found (unexpected behaviour)
				if (!pathElement || !path) return;

				const compiled = compile([path, animatePath]);

				const handleMorph = () => {
					const rectangle = block.getClientRects()[0];
					const dif = window.innerHeight - rectangle.top;
					const scrollAmount =
						Math.floor((dif / window.innerHeight) * 100) / 100;

					const morphPath = morph(compiled, [1 - scrollAmount, scrollAmount]);
					pathElement.setAttribute("d", morphPath);
				};

				handleMorph();
				document.addEventListener(
					"scroll",
					debounce(handleMorph, 10, false)
				);
			}
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	animateSvgs();
});
